import { onDocumentVisibleChange } from './common';
import { EventEmitter } from './event-emitter';
import { getTokenTenantId } from './login';
export var emitter = new EventEmitter();
export var storageTidKey = 'metis-unified-login-tid';
// let oldTid: string | null = defaultTid || null
// let newTid: string | null = oldTid
export var storageTidKeyOld = 'metis-unified-login-tid-old';
export var storageTidKeyNew = 'metis-unified-login-tid-new';
export function delaySetLocalStorage(fn) {
  setTimeout(function () {
    fn();
  }, 200);
}
delaySetLocalStorage(function () {
  var defaultTid = String(getTokenTenantId() || '');
  localStorage.setItem(storageTidKeyOld, defaultTid || 'null');
  localStorage.setItem(storageTidKeyNew, defaultTid || 'null');
  if (defaultTid) {
    localStorage.setItem(storageTidKey, defaultTid);
  }
});
export var listenTid = function listenTid() {
  var onStorage = function onStorage(e) {
    if (e.key === storageTidKey) {
      var newTid = localStorage.getItem(storageTidKeyNew);
      if (e.newValue !== newTid) {
        // oldTid = e.oldValue
        // newTid = e.newValue
        delaySetLocalStorage(function () {
          localStorage.setItem(storageTidKeyOld, e.oldValue);
          localStorage.setItem(storageTidKeyNew, e.newValue);
        });
        emitter.emit('schoolChange', {
          newTid: e.newValue === 'null' ? null : e.newValue,
          oldTid: e.oldValue === 'null' ? null : e.oldValue
        });
      }
    }
  };
  window.addEventListener('storage', onStorage);
  window.addEventListener('beforeunload', function () {
    window.removeEventListener('storage', onStorage);
  });
  onDocumentVisibleChange(function (hidden) {
    if (!hidden) {
      var newValue = String(getTokenTenantId() || '');
      var newTid = localStorage.getItem(storageTidKeyNew);
      if (newValue !== newTid) {
        // oldTid = newTid
        // newTid = newValue
        delaySetLocalStorage(function () {
          localStorage.setItem(storageTidKeyOld, newTid || '');
          localStorage.setItem(storageTidKeyNew, newValue);
        });
        emitter.emit('schoolChange', {
          newTid: newValue === 'null' ? null : newValue,
          oldTid: newTid === 'null' ? null : newTid
        });
      }
    }
  });
};